import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'negativeCurrency', standalone: true })
export class NegativeCurrencyPipe implements PipeTransform {
    transform(value: number | null | undefined, currencyCode: string = 'USD'): string {
        if (value === null || value === undefined) {
            return ''
        }

        const absValue = Math.abs(value)
        const formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(absValue)

        return value < 0 ? `(${formatted})` : formatted
    }
}
